import { collection, query, where, getDocs, getFirestore } from "firebase/firestore";
import app from "../config/firebase";

// Inicializar Firestore directamente aquí
const db = getFirestore(app);

/**
 * Debug utility for testing consent forms retrieval
 * 
 * @param {string} patientId - The ID of the patient to check consent forms for
 * @returns {Promise<Array>} - Array of consent forms or empty array if none found
 */
export async function debugConsentimientos(patientId) {
  if (!patientId) {
    console.error("DEBUG CONSENTIMIENTOS: No se proporcionó un ID de paciente");
    return { success: false, error: "ID de paciente no proporcionado", forms: [] };
  }

  console.log(`DEBUG CONSENTIMIENTOS: Buscando consentimientos para paciente ID: ${patientId}`);
  
  try {
    // Consulta a Firestore para obtener consentimientos
    const q = query(
      collection(db, "consentimientos"),
      where("pacienteId", "==", patientId),
      where("activo", "==", true)
    );
    
    console.log("DEBUG CONSENTIMIENTOS: Ejecutando consulta a Firestore...");
    
    const querySnapshot = await getDocs(q);
    
    if (querySnapshot.empty) {
      console.log("DEBUG CONSENTIMIENTOS: No se encontraron consentimientos");
      return { success: true, message: "No se encontraron consentimientos", forms: [] };
    }
    
    const consentimientos = [];
    querySnapshot.forEach(doc => {
      console.log(`DEBUG CONSENTIMIENTOS: Encontrado consentimiento con ID: ${doc.id}`);
      consentimientos.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    console.log(`DEBUG CONSENTIMIENTOS: Se encontraron ${consentimientos.length} consentimientos`);
    console.log("DEBUG CONSENTIMIENTOS: Datos recuperados:", consentimientos);
    
    return { 
      success: true, 
      message: `Se encontraron ${consentimientos.length} consentimientos`, 
      forms: consentimientos 
    };
  } catch (error) {
    console.error("DEBUG CONSENTIMIENTOS: Error al consultar consentimientos:", error);
    return { 
      success: false, 
      error: error.message || "Error desconocido", 
      forms: [] 
    };
  }
}

export default debugConsentimientos;
